import React, { useState } from "react";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";

export default function FounderUnlockBox({ onUnlocked }) {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  const unlock = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/billing/founder-unlock", { code });
      toast.success("Offerta Fondatore sbloccata");
      await onUnlocked();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Codice non valido");
    } finally { setBusy(false); }
  };

  return (
    <form onSubmit={unlock} data-testid="founder-unlock-box"
      className="mb-6 rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 flex flex-col sm:flex-row sm:items-center gap-3">
      <p className="flex-1 text-sm text-amber-900 flex items-center gap-2">
        <KeyRound style={{ width: 16, height: 16 }} className="shrink-0" /> Sei un tester? Inserisci il tuo codice per l'Offerta Fondatore
      </p>
      <div className="flex gap-2">
        <Input data-testid="founder-unlock-input" value={code} onChange={(e) => setCode(e.target.value)}
          placeholder="Codice tester" className="sm:w-44 bg-card" />
        <Button type="submit" data-testid="founder-unlock-btn" disabled={busy || !code.trim()}>
          {busy && <Loader2 className="w-4 h-4 animate-spin mr-1" />}Sblocca
        </Button>
      </div>
    </form>
  );
}
